package com.crowpay.extensions

import com.crowpay.User


val User.fullName: String get() = "$firstName $lastName"